import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useGenericDrawer } from "../../../hooks/drawer/useGenericDrawer";
import { ProcessPaymentForm } from "../payments/ProcessPaymentForm";
import { ControlcenterMelcoModelsPaymentListItem, ControlcenterMelcoModelsPaymentTransDetails } from "melco-shared-logic";
import { useEffect, useState } from "react";
import { usePaymentsGetTransDetails } from "../../../hooks/reports/usePaymentsGetTransDetails";



type ProcessPaymentDrawerProps = {
  isDrawerOpen: boolean;
  setDrawerOpen: (isDrawerOpen: boolean) => void;
  // processPaymentDetails: ControlcenterMelcoModelsPaymentListItem | undefined;
  id?: string
};

export const ProcessPaymentDrawer: React.FC<ProcessPaymentDrawerProps> = ({
  isDrawerOpen,
  setDrawerOpen,
  //  processPaymentDetails,
  id }) => {
  const { t } = useTranslation();

  const referenceDrawer = useGenericDrawer();
  const [paymentTransactionDetails, setPaymentTransactionDetails] = useState<
    ControlcenterMelcoModelsPaymentTransDetails | undefined
  >();
  const { data } = usePaymentsGetTransDetails(id);

  useEffect(() => {
    setPaymentTransactionDetails(data);
  }, [data]);

  return (
    <Drawer
      title={t("payments.drawer.title")}
      placement="right"
      width={1000}
      closable={true}
      onClose={() => setDrawerOpen(false)}
      open={isDrawerOpen}
      bodyStyle={{ padding: "32px" }}
    >
      {isDrawerOpen && (
        <ProcessPaymentForm
          referenceDrawer={referenceDrawer}
          onCloseDrawer={setDrawerOpen}
          processPaymentDetails={paymentTransactionDetails}
        />
      )}
    </Drawer>
  );
};
